import React, { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'

const RootErrorBoundary = () => {
  const error = useRouteError()

  useEffect(() => {
    // 檢查是否為 ChunkLoadError
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk')

    if (isChunkError) {
      const hasRefreshed = JSON.parse(sessionStorage.getItem('chunk_retry_refreshed') || 'false')
      if (!hasRefreshed) {
        sessionStorage.setItem('chunk_retry_refreshed', 'true')
        window.location.reload()
        return
      }
    }
  }, [error])

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>頁面載入異常</h2>
      <p>網站內容已更新，請嘗試手動重新整理頁面。</p>
      <button
        onClick={() => {
          sessionStorage.setItem('chunk_retry_refreshed', 'false')
          window.location.reload()
        }}
        style={{
          padding: '0.5rem 1.5rem',
          backgroundColor: '#4f9bb8',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        重新整理
      </button>
    </div>
  )
}

export default RootErrorBoundary